export default __webpack_public_path__ + "media/images/brands/xpress/backgrounds/bg-04-246cd18bee7a23c7cbff88d79346d74e.jpg";